import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { useInput } from "@website/ui/datepicker/components/input/input.hook";
import styles from "@website/ui/datepicker/components/input/input.module.scss";
import { InputPropertiesType } from "@website/ui/datepicker/components/input/input.types";
import { TextField } from "@website/ui/text-field";
import { FC } from "react";
export const Input: FC<InputPropertiesType> = properties => {
  const $ = _c(24);
  const {
    mode,
    fullWidth,
    helperText,
    error,
    changeableMode,
    size: t0,
    inputClassName,
    hideMiddleLine,
    labelClassName
  } = properties;
  const size = t0 === undefined ? "default" : t0;
  const {
    rootProps,
    startTextFieldProperties,
    endEnableButtonProperties,
    endTextFieldProperties,
    endEnableButtonText
  } = useInput(properties);
  const t1 = `${styles.input} ${fullWidth ? styles["full-width"] : ""} ${error ? styles.error : ""}`;
  let t2;
  if ($[0] !== inputClassName || $[1] !== labelClassName || $[2] !== startTextFieldProperties) {
    t2 = <div className={styles["text-field-container"]}><TextField {...startTextFieldProperties} inputClassName={inputClassName} labelClassName={labelClassName} /></div>;
    $[0] = inputClassName;
    $[1] = labelClassName;
    $[2] = startTextFieldProperties;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== changeableMode || $[5] !== endEnableButtonProperties || $[6] !== endEnableButtonText || $[7] !== endTextFieldProperties || $[8] !== hideMiddleLine || $[9] !== inputClassName || $[10] !== labelClassName || $[11] !== mode || $[12] !== size) {
    t3 = mode === "single" ? changeableMode ? <><div className={`${styles.middle} ${size === "dense" ? styles.middle__dense : styles.middle__default}`}><div className={styles["middle-line"]} /></div><button className={styles["enable-second-mode-button"]} {...endEnableButtonProperties}>{endEnableButtonText}<MaterialIcon name="add" variant="outlined" /></button></> : null : <>{!hideMiddleLine && <div className={styles.middle}><div className={styles["middle-line"]} /></div>}<div className={styles["text-field-container"]}><TextField {...endTextFieldProperties} inputClassName={inputClassName} labelClassName={labelClassName} /></div></>;
    $[4] = changeableMode;
    $[5] = endEnableButtonProperties;
    $[6] = endEnableButtonText;
    $[7] = endTextFieldProperties;
    $[8] = hideMiddleLine;
    $[9] = inputClassName;
    $[10] = labelClassName;
    $[11] = mode;
    $[12] = size;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t2 || $[15] !== t3) {
    t4 = <div className={styles["inputs-container"]}>{t2}{t3}</div>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== helperText) {
    t5 = helperText ? <div className={styles["helper-text"]}>{helperText}</div> : null;
    $[17] = helperText;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== rootProps || $[20] !== t1 || $[21] !== t4 || $[22] !== t5) {
    t6 = <div {...rootProps} className={t1}>{t4}{t5}</div>;
    $[19] = rootProps;
    $[20] = t1;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  return t6;
};